import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { LinkItemApi } from "./LinkItemApi";

export type LinkCategoryDataType = Partial<ApiSchema["LinkCategory"]["type"]>;

class Api extends GenericModelApi<"LinkCategory", LinkCategoryDataType> {
    async deleteCategoryWithItems(categoryId: string): Promise<void> {
        const { items } = await LinkItemApi.fetchAllByCategoryId(categoryId);
        await Promise.all((items || []).map((item) => (item.id ? LinkItemApi.delete(item.id) : Promise.resolve())));
        await this.delete(categoryId);
    }
}

export const LinkCategoryApi = new Api("LinkCategory", "title", "ASC");
